export enum ParamsNames {
  LOCALE = "locale",
  ORGANIZATION_CODE = "organizationCode",
  SITE_ID = "siteId",
  BUILDING_ID = "buildingId",
  FLOOR_ID = "floorId",
  ASSET_ID = "assetId",
  FILE_NAME = "fileName",
}

export type AllParams = {
  [p in ParamsNames]: string;
};
